import "./leadership-metrics.css";

// Short Report: Leadership Metrics
const LeadershipMetricsReport = (comparisonResult) => {
  console.log("Comparison Result:", comparisonResult);
  // const comparisonResult = {
  //   summary: {
  //     entitiesCompared: 2,
  //     team1LeadershipReady: 7,
  //     team2LeadershipReady: 20,
  //     team1Nominated: 5,
  //     team2Nominated: 30,
  //   },
  //   metrics: [
  //     {
  //       name: "Average Leadership Readiness of Team 1",
  //       type: "Team A",
  //       performance: 65, // 65% leadership readiness
  //     },
  //     {
  //       name: "Average Leadership Readiness of Team 2",
  //       type: "Team B",
  //       performance: 75, // 75% leadership readiness
  //     },
  //     {
  //       name: "Average Experience of Team 1",
  //       type: "Team A",
  //       performance: 70, // 70% experience level
  //     },
  //     {
  //       name: "Average Experience of Team 2",
  //       type: "Team B",
  //       performance: 85, // 85% experience level
  //     },
  //   ],
  // }

  // Split metrics into two groups for the two progress bar sections
  // const leadershipReadinessMetrics = comparisonResult.metrics.filter(
  //   (_, index) => index < 2
  // );
  // const experienceMetrics = comparisonResult.metrics.filter(
  //   (_, index) => index >= 2
  // );

  return (
    <div className="tt-lm-short-report-container">
      <div className="tt-lm-report-header">
        <h3>Leadership Metrics</h3>
        <p>
          Quick overview of leadership readiness and experience between the
          selected teams
        </p>
      </div>

      <div className="tt-lm-comparison-summary">
        <div className="tt-lm-summary-card">
          <div className="tt-lm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-lm-summary-content">
            <div className="tt-lm-summary-value">
              {
                comparisonResult?.comparisonData?.leadershipMetricsShortReport
                  ?.teamALeadershipReadyCount
              }
            </div>
            <div className="tt-lm-summary-label">
              {" "}
              {
                comparisonResult?.comparisonData?.detailedReport?.teamADetails
                  ?.teamName
              }{" "}
              Leadership Ready
            </div>
          </div>
        </div>

        <div className="tt-lm-summary-card">
          <div className="tt-lm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-lm-summary-content">
            <div className="tt-lm-summary-value">
              {
                comparisonResult?.comparisonData?.leadershipMetricsShortReport
                  ?.teamBLeadershipReadyCount
              }
            </div>
            <div className="tt-lm-summary-label">
              {" "}
              {
                comparisonResult?.comparisonData?.detailedReport?.teamBDetails
                  ?.teamName
              }{" "}
              Leadership Ready
            </div>
          </div>
        </div>

        <div className="tt-lm-summary-card">
          <div className="tt-lm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-lm-summary-content">
            <div className="tt-lm-summary-value">
              {
                comparisonResult?.comparisonData?.leadershipMetricsShortReport
                  ?.teamANominationsCount
              }
            </div>
            <div className="tt-lm-summary-label">
              {
                comparisonResult?.comparisonData?.detailedReport?.teamADetails
                  ?.teamName
              }{" "}
              Nominated for Leadership
            </div>
          </div>
        </div>

        <div className="tt-lm-summary-card">
          <div className="tt-lm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-lm-summary-content">
            <div className="tt-lm-summary-value">
              {
                comparisonResult?.comparisonData?.leadershipMetricsShortReport
                  ?.teamBLeadershipReadyCount
              }
            </div>
            <div className="tt-lm-summary-label">
              {
                comparisonResult?.comparisonData?.detailedReport?.teamBDetails
                  ?.teamName
              }{" "}
              Leadership Ready
            </div>
          </div>
        </div>
      </div>

      {/* Leadership Readiness Metrics */}
      <div className="tt-lm-metrics-comparison">
        <h3>Average Leadership Readiness</h3>
        <div className="tt-lm-metrics-chart">
          {comparisonResult?.comparisonData?.leadershipMetricsShortReport?.avgLeadershipReadiness.map(
            (metrics, index) => (
              <div key={index} className="tt-lm-metric-bar-container">
                <div className="tt-lm-metric-info">
                  <span className="tt-lm-metric-name">{metrics?.name}</span>
                  {/* <span className="tt-lm-metric-type">{metrics.type}</span> */}
                </div>
                <div className="tt-lm-metric-bar">
                  <div
                    className="tt-lm-metric-fill"
                    style={{ width: `${Math.round(metrics?.avgValue)}%` }}
                  ></div>
                  <span className="tt-lm-metric-value">
                    {Math.round(metrics?.avgValue)}%
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* Experience Metrics */}
      {/* <div className="tt-lm-metrics-comparison">
        <h3>Compare Average Experience</h3>
        <div className="tt-lm-metrics-chart">
          {experienceMetrics.map((metric, index) => (
            <div key={index} className="tt-lm-metric-bar-container">
              <div className="tt-lm-metric-info">
                <span className="tt-lm-metric-name">{metric.name}</span>
                <span className="tt-lm-metric-type">{metric.type}</span>
              </div>
              <div className="tt-lm-metric-bar">
                <div
                  className="tt-lm-metric-fill"
                  style={{ width: `${Math.round(metric.performance)}%` }}
                ></div>
                <span className="tt-lm-metric-value">
                  {Math.round(metric.performance)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      {/* Analysis Overview */}
      <div className="tt-lm-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-lm-analysis-paragraph">
          <p>
            {
              comparisonResult?.comparisonData?.leadershipMetricsShortReport
                ?.overview
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeadershipMetricsReport;
